<div *ngIf="message" class="alert" [ngClass]="[type, font?.size]">
  <div class="icon" [ngClass]="[type, font?.size]"></div>
  <p class="message">{{ message }}</p>
</div>
